module.exports = {
	mapView: `/apps/view`,
	drawView: `/apps/draw`,
	loginPage: '/login',
	awd: '/apps/:appName',
	home: '/apps',
	telematics: `/apps/telematics`,
	sugarcane: `/apps/sugarcane`,
	programs: '/apps/programs',
};
